import React from 'react';
import { SvgIconProps } from '@mui/material';

export const UncheckedCandidatesIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M23.6042 15.2161V15.2093M21 7.55588C21.3478 6.44593 22.3822 5.64081 23.6042 5.64081C25.1115 5.64081 26.3333 6.86567 26.3333 8.37662C26.3333 10.5745 24.0433 9.49389 23.6667 11.7964M6.33333 17.9519H17C19.9455 17.9519 22.3333 20.4016 22.3333 23.4235V26.1593H1V23.4235C1 20.4016 3.38781 17.9519 6.33333 17.9519ZM17 7.00871C17 10.0306 14.6122 12.4803 11.6667 12.4803C8.72115 12.4803 6.33333 10.0306 6.33333 7.00871C6.33333 3.98683 8.72115 1.53711 11.6667 1.53711C14.6122 1.53711 17 3.98683 17 7.00871Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default UncheckedCandidatesIcon;
